import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueCoreVideoPlayer from 'vue-core-video-player'
import funcionesVarias from '@/services/funciones.varias'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB4-JLBFcJxL7YpPB51Yz65XRJk5ZlIxs0',
    libraries: 'places',
  }
});
Vue.use(VueCoreVideoPlayer);
Vue.use(require('vue-moment'));
Vue.config.productionTip = false;

Vue.filter('formatoMoneda', function (value) {
  if (!value) return value;
  return funcionesVarias.formatoMoneda(value);  
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
